import { createApiSaga } from '../../../sagaGenerator';
import { apiDelete, apiGet } from '../../../../middleware/api';
import {
  TSU_REL_RUNUP_DATA_TSUNAMI_REQUEST,
  TSU_REL_RUNUP_DATA_RUNUP_REQUEST,
  TSU_REL_RUNUP_DATA_DELETE_RUNUP_REQUEST,
  TSU_REL_RUNUP_DATA_RUNUP_SUCCESS,
  TSU_REL_RUNUP_DATA_TSUNAMI_SUCCESS,
  TSU_REL_RUNUP_DATA_DELETE_RUNUP_SUCCESS,
  TSU_REL_RUNUP_DATA_RUNUP_FAILURE,
  TSU_REL_RUNUP_DATA_TSUNAMI_FAILURE,
  TSU_REL_RUNUP_DATA_DELETE_RUNUP_FAILURE,
} from './tsunamiRelatedRunupsReducer';


const deleteRunupSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}`, ...action }),
  requestType: TSU_REL_RUNUP_DATA_DELETE_RUNUP_REQUEST,
  successType: TSU_REL_RUNUP_DATA_DELETE_RUNUP_SUCCESS,
  failureType: TSU_REL_RUNUP_DATA_DELETE_RUNUP_FAILURE,
  successMessage: 'Deleted',
});

const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/info`, ...action }),
  requestType: TSU_REL_RUNUP_DATA_TSUNAMI_REQUEST,
  successType: TSU_REL_RUNUP_DATA_TSUNAMI_SUCCESS,
  failureType: TSU_REL_RUNUP_DATA_TSUNAMI_FAILURE,
});

const getRunupsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/runups`, ...action }),
  requestType: TSU_REL_RUNUP_DATA_RUNUP_REQUEST,
  successType: TSU_REL_RUNUP_DATA_RUNUP_SUCCESS,
  failureType: TSU_REL_RUNUP_DATA_RUNUP_FAILURE,
});

export const relatedRunupSagas = [
  deleteRunupSaga,
  getTsunamiSaga,
  getRunupsSaga,
];
